import { Col, Card, Button, Form } from "react-bootstrap";
import "../styles/form.css";
import { useState } from "react";
import Container from "react-bootstrap/Container";
import { useNavigate } from "react-router-dom";

const LEAD_TYPE_LABELS = {
  Mortgage: "Jelzáloghitel",
  Personal_loan: "Személyi kölcsön",
  retail_account: "Lakossági bankszámla",
  Pension: "Nyugdíjmegtakarítás",
  risk_insurance: "Kockázati életbiztosítás",
};

/**
 * @param {string} leadType "Mortgage" | "Personal_loan" | "retail_account" | "Pension" | "risk_insurance"
 */
export default function RetailLeadForm({ leadType }) {
  const [validated, setValidated] = useState(false);
  const [status, setStatus] = useState("idle");
  const navigate = useNavigate();

  const leadTypeLabel = LEAD_TYPE_LABELS[leadType] || leadType || "Általános";

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity()) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    setValidated(true);
    setStatus("loading");

    try {
      const formData = new FormData(form);
      formData.append("leadType", leadType || "");
      formData.append("leadTypeLabel", leadTypeLabel);

      const response = await fetch("/php/send_retail.php", {
        method: "POST",
        body: formData,
      });

      if (response.status === 200) {
        setStatus("success");
        navigate("/koszonjuk", { state: { formType: leadTypeLabel } });
      } else {
        setStatus("error");
      }
    } catch (err) {
      setStatus("error");
    }
  };

  return (
    <Container id="ajanlat" className="d-flex justify-content-center p-0">
      <Card className="card form-card px-4 py-2">
        <Form
          noValidate
          validated={validated}
          onSubmit={handleSubmit}
          style={{ maxWidth: "800px", margin: "auto", textAlign: "center" }}
        >
          <Form.Group className="p-1" style={{ textAlign: "left" }}>
            <Form.Label className="mb-0 ms-1 fw-bold">Név</Form.Label>
            <Form.Control name="name" placeholder="pl.: Minta János" required />
            <Form.Control.Feedback type="invalid">
              Kérlek add meg a neved.
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="p-1" style={{ textAlign: "left" }}>
            <Form.Label className="mb-0 ms-1 fw-bold">Telefonszám</Form.Label>
            <Form.Control
              name="phone"
              placeholder="pl.: +36 20 123 4567"
              required
            />
            <Form.Control.Feedback type="invalid">
              Kérlek adj meg egy érvényes telefonszámot.
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="p-1" style={{ textAlign: "left" }}>
            <Form.Label className="mb-0 ms-1 fw-bold">Email cím</Form.Label>
            <Form.Control
              name="email"
              type="email"
              placeholder="pl.: janos@example.hu"
              required
            />
            <Form.Control.Feedback type="invalid">
              Kérlek adj meg egy érvényes email címet.
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="p-1" style={{ textAlign: "left" }}>
            <Form.Label className="mb-0 ms-1 fw-bold">Település</Form.Label>
            <Form.Control name="city" placeholder="pl.: Budapest" required />
            <Form.Control.Feedback type="invalid">
              Kérlek add meg a településed.
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="p-1" style={{ textAlign: "left" }}>
            <Form.Label className="mb-0 ms-1 fw-bold">
              Havi jövedelem (nettó, Ft)
            </Form.Label>
            <Form.Control
              name="income"
              type="number"
              min="0"
              step="1000"
              placeholder="pl.: 450000"
              required
            />
            <Form.Control.Feedback type="invalid">
              Kérlek add meg a havi nettó jövedelmed.
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="p-1" style={{ textAlign: "left" }}>
            <Form.Label className="mb-0 ms-1 fw-bold d-block">
              Szerepel(t) a KHR-ben (negatív listán)?
            </Form.Label>
            <div className="d-flex gap-4">
              <Form.Check
                type="radio"
                id="khr-nem"
                name="khr"
                value="Nem"
                label="Nem"
                required
              />
              <Form.Check
                type="radio"
                id="khr-igen"
                name="khr"
                value="Igen"
                label="Igen"
                required
              />
            </div>
            <Form.Control.Feedback type="invalid" className="d-block">
              Kérlek válaszd ki a KHR státuszod.
            </Form.Control.Feedback>
          </Form.Group>

          <Col xs={12} className="d-flex justify-content-center my-3">
            <Button
              className="btn btn-primary"
              type="submit"
              disabled={status === "loading" || status === "success"}
            >
              {status === "loading"
                ? "Küldés..."
                : status === "success"
                  ? "Sikeres beküldés"
                  : status === "error"
                    ? "Sikertelen beküldés"
                    : "Ajánlatot kérek"}
            </Button>
          </Col>
          {status === "error" && (
            <Col xs={12}>
              <p className="text-danger mb-0">
                Kérjük írj emailt nekünk:
                <br />
                <strong>financials@financials.hu</strong>
              </p>
            </Col>
          )}
          <div className="small" style={{ textAlign: "left" }}>
            Az űrlap elküldésével elfogadod az{" "}
            <a className="form-section-a" href="/adatkezelesi-tajekoztato">
              adatkezelési tájékoztatóban
            </a>{" "}
            foglaltakat.
          </div>
        </Form>
      </Card>
    </Container>
  );
}
